import React, { useState } from "react";
import {
  TextField,
  Button,
  Grid,
  Checkbox,
  FormControlLabel,
  Box,
  MenuItem
} from "@mui/material";
import axios from "axios";
import { useSnackbar } from "src/components/snackbar/useSnackbar";
import { useNavigate } from "react-router";
import CircularProgress from "@mui/material/CircularProgress";
import { post } from "src/services/httpClient.service";



const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

const Addvendor = () => {
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState<any>({
    vendorMail: "",
    vendorName: "",
    vendorContactNo: "",
    streamEngine: "",
    streamEngineUrl: "",
    channelPort: "",
    apiPort: "",
    //galleryPort: "",

    hasDrmAccess: false,
    //drmUrl: "",
    //drmUserName: "",
    //drmLicenseKey: "",

    //enableCommonGallery: false,
    //fileUploadUrl: "",
    //fileUploadPort: "",
    status: "active",

    enableMediaServer: false,
    enableCommonMediaServer: false,
    mediaServerUrl: "",
    mediaServerChannelPort: "",

    enablePublicUrl: false,
    enableCommonPublicUrl: false,
    publicUrl: "",
    publicChannelPort: "",
    mobilePackageName: "",
    tvPackageName: "",
  });

  //valiations

  const [errors, setErrors] = useState({
    vendorMail: "",
    vendorName: "",
    vendorContactNo: "",
    streamEngine: "",
    streamEngineUrl: "",
    channelPort: "",
    apiPort: "",
    drmUrl: "",
    drmUserName: "",
    drmLicenseKey: "",
    //galleryPort: "",
    //drmUrl: "",
    //drmUserName: "",
    //drmLicenseKey: "",
    fileUploadUrl: "",
    fileUploadPort: "",
    status: "",
    mediaServerUrl: "",
    mediaServerChannelPort: "",
    publicUrl: "",
    publicChannelPort: "",
    mobilePackageName: "",
    tvPackageName: "",
  });

//validation form
const validateForm = () => {
  let tempErrors: any = {};

  let isValid = true;

  // Required fields
  const requiredFields = [
    "vendorMail",
    "vendorName",
    "vendorContactNo",
    "streamEngine",
    "streamEngineUrl",
    "channelPort",
    "apiPort",
    //"drmUrl",
    //"drmUserName",
    //"drmLicenseKey",
    //"galleryPort",
    "status",
    //"drmUrl",
    //"drmUserName",
    //"drmLicenseKey",
    //"fileUploadUrl",
    //"fileUploadPort",
    "mediaServerUrl",
    "mediaServerChannelPort",
    "publicUrl",
    "publicChannelPort",
    "mobilePackageName",
    "tvPackageName",
    ];

  requiredFields.forEach((field) => {
    if (!form[field]?.trim()) {
      tempErrors[field] = `${field} is required`;
      isValid = false;
    }
  });

  // Email validation
  if (form.vendorMail && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.vendorMail)) {
    tempErrors.vendorMail = "Enter a valid email";
    isValid = false;
  }

  // Phone validation (10 digits)
  if (form.vendorContactNo && !/^\d{10}$/.test(form.vendorContactNo)) {
    tempErrors.vendorContactNo = "Contact number must be 10 digits";
    isValid = false;
  }

  setErrors(tempErrors);
  return isValid;
};



  const handleChange = (e: any) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleCheck = (e: any) => {
  const { name, checked } = e.target;

  setForm((prev: any) => ({
    ...prev,
    [name]: checked,

    ...(name === "hasDrmAccess" && !checked && {
      enableMediaServer: false,
    }),

    ...(name === "enablePublicUrl" && !checked && {
      enableCommonPublicUrl: false,
    }),
  }));
};


const handleSubmit = async () => {
     if (!validateForm()) return;  
  try {
    setLoading(true);

    const res = await post(`${API_BASE_URL}/api/vendors`, form);
    
     
    if (res.status == "OK") {
      navigate('/vendors/vendorDetails');
      showSnackbar('success','success')
    } else {
      // showSnackbar(res?.data, 'error');
    }
  } catch (err) {
    console.error(err);
    showSnackbar(err?.message || "Error creating vendor", 'error');
  } finally {
    setLoading(false);  // 🔥 important to avoid memory leak warning
  }
};






  return (
    <Box sx={{ p: 3 }}>
        <Grid container spacing={2}>

      {/* TEXT FIELDS */}

      {[
        "vendorMail",
        "vendorName",
        "vendorContactNo",
        "streamEngine",
        "streamEngineUrl",
        "channelPort",
        "apiPort",
        "mediaServerUrl",
        "mediaServerChannelPort",
        "publicUrl",
        "publicChannelPort",
        "mobilePackageName",
        "tvPackageName"
      ].map((field) => (
        <Grid item xs={12} sm={6} key={field}>

          {field === "streamEngine" ? (
            <TextField
              select
              fullWidth
              label="Stream Engine Type"
              name={field}
              value={(form as any)[field]}
              onChange={handleChange}
              error={!!errors[field]}
              helperText={errors[field]}
            >
              <MenuItem value="INTERNAL">INTERNAL</MenuItem>
              <MenuItem value="EXTERNAL">EXTERNAL</MenuItem>
            </TextField>
          ) : (
            <TextField
              fullWidth
              label={field}
              name={field}
              value={(form as any)[field]}
              onChange={handleChange}
              error={!!errors[field]}
              helperText={errors[field]}
            />
          )}

        </Grid>
      ))}


      {/* {[
        "vendorMail",
        "vendorName",
        "vendorContactNo",
        "streamEngine",
        "streamEngineUrl",
        "channelPort",
        "apiPort",
      
        //"galleryPort",
        //"drmUrl",
        //"drmUserName",
        //"drmLicenseKey",
        //"fileUploadUrl",
        //"fileUploadPort",
    
        "mediaServerUrl",
        "mediaServerChannelPort",
        "publicUrl",
        "publicChannelPort",
        "mobilePackageName",
        "tvPackageName"
      ].map((field) => (
        <Grid item xs={12} sm={6} key={field}>
          <TextField
            fullWidth
            label={field}
            name={field}
            value={(form as any)[field]}
            onChange={handleChange}
             error={!!errors[field]}
             helperText={errors[field]}
          />
        </Grid>
      ))} */}

      {form.hasDrmAccess && (
  <>
    <Grid item xs={12} sm={6}>
      <TextField
        fullWidth
        label="drmUrl"
        name="drmUrl"
        value={form.drmUrl}
        onChange={handleChange}
        error={!!errors.drmUrl}
        helperText={errors.drmUrl}
      />
    </Grid>

    <Grid item xs={12} sm={6}>
      <TextField
        fullWidth
        label="drmUserName"
        name="drmUserName"
        value={form.drmUserName}
        onChange={handleChange}
      />
    </Grid>

    <Grid item xs={12} sm={6}>
      <TextField
        fullWidth
        label="drmLicenseKey"
        name="drmLicenseKey"
        value={form.drmLicenseKey}
        onChange={handleChange}
      />
    </Grid>
  </>
)}


<Grid item xs={12} sm={6}>
  <TextField
    select
    fullWidth
    label="Status"
    name="status"
    value={form.status}
    onChange={handleChange}
    SelectProps={{ native: true }}
  >
    <option value="">Select Status</option>
    <option value="ACTIVE">ACTIVE</option>
    <option value="INACTIVE">INACTIVE</option>
  </TextField>
</Grid>

      {/* CHECKBOX FIELDS */}
     <Grid item xs={12} sm={6}>
  <FormControlLabel
    control={
      <Checkbox
        name="hasDrmAccess"
        checked={form.hasDrmAccess}
        onChange={handleCheck}
      />
    }
    label="Has DRM Access"
  />
</Grid>


  <Grid item xs={12} sm={6}>
    <FormControlLabel
      control={
        <Checkbox
          name="enableMediaServer"
          checked={form.enableMediaServer}
          onChange={handleCheck}
        />
      }
      label="Enable Media Server"
    />
  </Grid>


{form.enableMediaServer && ( <Grid item xs={12} sm={6}>
  <FormControlLabel
    control={
      <Checkbox
        name="enableCommonMediaServer"
        checked={form.enableCommonMediaServer}
        onChange={handleCheck}
      />
    }
    label="Enable Common Media Server"
  />
</Grid>

)}


<Grid item xs={12} sm={6}>
  <FormControlLabel
    control={
      <Checkbox
        name="enablePublicUrl"
        checked={form.enablePublicUrl}
        onChange={handleCheck}
      />
    }
    label="Enable Public URL"
  />
</Grid>

{form.enablePublicUrl && (
  <Grid item xs={12} sm={6}>
    <FormControlLabel
      control={
        <Checkbox
          name="enableCommonPublicUrl"
          checked={form.enableCommonPublicUrl}
          onChange={handleCheck}
        />
      }
      label="Enable Common Public URL"
    />
  </Grid>
)}

      {/* SUBMIT BUTTON */}
      <Grid item xs={12}>
        <Box sx={{display:'flex',gap:'10px',justifyContent: "flex-end"}}>
            <Button
  variant="contained"
  onClick={handleSubmit}
  disabled={loading}
  startIcon={loading ? <CircularProgress size={20} /> : null}
>
  {loading ? "Creating..." : "Create Vendor"}
</Button>
<Button variant="contained" onClick={()=>navigate('/vendors/vendorDetails')}>cancel</Button>

        </Box>
        
      </Grid>
     


    </Grid>
    
    </Box>
    
  );
};

export default Addvendor;
